<div class="landing-container">
  <nav class="main-nav">
    <div class="nav-left">
      <div class="logo">
        <img [src]="logoSrc" alt="Journey Logo">
      </div>
      <h1 class="title">{{title}}</h1>
    </div>
    <div class="nav-links">
      <a routerLink="/home">{{ 'labels.home' | translate }}</a>
      <a routerLink="/stories">{{ 'labels.stories' | translate }}</a>
      <a routerLink="/about">{{ 'labels.about' | translate }}</a>
      <a routerLink="/login" class="login-btn">{{ 'labels.login' | translate }}</a>
      <a routerLink="/register" class="register-btn">{{ 'buttons.registerFree' | translate }}</a>
    </div>
  </nav>

  <main class="hero-section">
    <div class="hero-content">
      <h1>{{ 'messages.heroTitle' | translate }}<br>
          <span class="highlight">{{ 'messages.heroHighlight' | translate }}</span></h1>
      <p class="subtitle">{{ 'messages.heroSubtitle' | translate }}</p>
      <button class="cta-button" routerLink="/create-story">
        {{ 'buttons.createStory' | translate }}
      </button>
      <p class="features">
        ✨ {{ 'messages.heroFeatureInteractive' | translate }}<br>
        🎨 {{ 'messages.heroFeatureIllustrations' | translate }}<br>
        📚 {{ 'messages.heroFeatureCharacters' | translate }}
      </p>
    </div>
    <div class="hero-image">
      <img [src]="heroImageSrc" alt="Journey Hero Illustration">
    </div>
  </main>
</div> 